"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanPath = void 0;
var cianApiPattern = /^\/(public\/)?v\d+\//;
var numberPattern = /\d+/g;
var slashPattern = /\/{2,}/g;
function cleanPath(pathname) {
    var cianApi = pathname.match(cianApiPattern);
    var prefix = '';
    var api = pathname;
    if (cianApi) {
        prefix = cianApi[0];
        api = pathname.slice(prefix.length);
    }
    // Возможно цифры нужно заменять на символ N
    return prefix + api.replace(numberPattern, '').replace(slashPattern, '/');
}
exports.cleanPath = cleanPath;
//# sourceMappingURL=pathSimplified.js.map